module.exports = __webpack_public_path__ + "img/Federal Board.fcbd3d59.png";